import type { FC } from 'react';
import { useEventListener } from 'usehooks-ts';
import { useStore } from '../store';

// Kept at module scope: useEventListener re-subscribes whenever the options
// identity changes, so an inline object would rebind on every render.
const KEYPRESS_OPTIONS = { capture: true } as const;

export const KeyPressManager: FC = () => {
  const toggleTimer = useStore((state) => state.actions.toggleTimer);

  function handleKeyPress(event: KeyboardEvent) {
    const focusEl = window.document.activeElement;

    if (
      (focusEl == null ||
        !['input', 'textarea', 'button'].includes(focusEl.tagName.toLowerCase())) &&
      event.key === ' '
    ) {
      event.preventDefault();
      toggleTimer();
    }
  }

  useEventListener('keypress', handleKeyPress, undefined, KEYPRESS_OPTIONS);

  return null;
};
